@if ((auctionData$ | async); as auction) {
  <div
    class="head-wrapper"
    [style.backgroundColor]="'rgba(' + (themeSvc.activeBackground$ | async) + ', .15)'">

    <div class="inner">

      <app-bid />

      <punk-image
        [auction]="auction"
        [dimensions]="{ width: 600, height: 600 }"
        [animate]="true">
      </punk-image>

      <app-punk-info
        [activeAuction]="auction">
      </app-punk-info>
    </div>
  </div>

  <!-- {{ (auctionData$ | async) | json }} -->
  
  <div class="copy-wrapper">
  
    <div class="left">
      @if (auction.punkId !== '-1') {
        <p>Welcome to the auction house for <span class="pink">CryptoPunk {{ auction.punkId }}</span>. Auctions are a new and exciting way to buy and sell punks. Try it out today!</p>
      }
    </div>
  
    <div class="right"></div>
  </div>
  
}